const utils = require('../../utils')
import AppHeader from '../AppHeader'
import SubMenu from '../SubMenu'
import { mapGetters } from 'vuex'
import $ from 'jquery'
global.jQuery = $
window.jQuery = $

export default {
  name: 'propose-search-list',
  created () {
    this.getShop()
    this.getTask()
    if (window.sessionStorage.getItem('propose_list_search_conditions')) {
      const data = JSON.parse(window.sessionStorage.getItem('propose_list_search_conditions'))
      const method = data['method']
      const id = data['id']
      const param = data['param']
      this.keyword = data['keyword']
      this.search(method, id, param)
      this.getTask()
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  updated () {
    const wr = $('.wrapper')
    if (wr.height() !== 112 && wr.height() !== 207 && wr.height() < $(window).height() && this.searchCallbackFlag === true && this.shopCallbackFlag === true) {
      wr.height($(window).height())
    }
    if (window.sessionStorage.getItem('propose_list_scroll_top') && this.searchCallbackFlag === true && this.shopCallbackFlag === true) {
      const data = JSON.parse(window.sessionStorage.getItem('propose_list_scroll_top'))
      if (data['path'] === this.$router.history.current.path) {
        $(window).scrollTop(data['scrollTop'])
        // 自動スクロール後の手動スクロールイベントの発生でセッションからスクロール情報を削除する。そのためのフラグ。
        this.isScrollDoneFlag = true
      }
    }
  },
  data () {
    return {
      shopCallbackFlag: false,
      searchCallbackFlag: false,
      keywordSearchCallbackFlag: false,
      keyword: null,
      searchShow: '',
      padding: '',
      selectShopName: '',
      isScrollDoneFlag: false,
      goodPushing: false
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    const $win = $(window)
    $win.on('load scroll', function () {
      $('.submenu__list').removeClass('gheader-fix')
      $('.wrapper').css('margin-top', 0)
    })
    if (to.name === 'proposeDetail') {
      const savedata = {
        'path': this.$router.history.current.path,
        'scrollTop': $(window).scrollTop()
      }
      window.sessionStorage.setItem('propose_list_scroll_top', JSON.stringify(savedata))
    } else {
      window.sessionStorage.removeItem('propose_list_scroll_top')
      window.sessionStorage.removeItem('propose_list_search_conditions')
    }
    next()
  },
  computed: {
    ...mapGetters({
      proposeTask: 'proposeTask',
      shop: 'shopDetail',
      proposes: 'proposeList',
      getNewGoodsCount: 'newGoodsCount',
      getNewGoodId: 'newGoodId',
      keywordShops: 'keywordShops',
      keywordUsers: 'keywordUsers'
    }),
    isMyself () {
      return this.profile.attributes['asovi-access-token'] === window.localStorage.getItem('access_token')
    },
    profileImagePath () {
      return this.profile.attributes['profile-image-path'] ? this.profile.attributes['profile-image-path'] : ''
    },
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      const d = new Date()
      const year = d.getFullYear()
      const month = d.getMonth() + 1
      const day = d.getDate()
      const hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      const min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      const sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    }
  },
  components: {
    AppHeader,
    SubMenu
  },
  methods: {
    getShop: function () {
      this.shopCallbackFlag = false
      const self = this
      const data = {}
      const callback = function () {
        self.shopCallbackFlag = true
      }
      this.$store.dispatch('SHOP_DETAIL', {id: window.localStorage.getItem('shop_id'), data: data, callback: callback})
    },
    search: function (method, id, param) {
      this.clearFlags()
      const url = null
      const self = this
      const callback = function () {
        self.searchCallbackFlag = true
        self.focusOut()
      }
      let data
      if (method === 'shop') {
        this.selectShopName = param || ''
        data = {
          'shop_id': id,
          'propose_status': ['approved', 'adopted']
        }
      } else if (method === 'user') {
        data = {
          'user_id': id
        }
      } else if (method === 'keyword') {
        data = {
          'keyword': self.keyword
        }
      }
      const savedata = {
        'method': method,
        'id': id,
        'param': param,
        'keyword': (self.keyword) ? self.keyword : ''
      }
      window.sessionStorage.setItem('propose_list_search_conditions', JSON.stringify(savedata))
      this.$store.dispatch('PROPOSE_LIST_SEARCH', {url: url, data: data, callback: callback})
    },
    keywordSearch: function () {
      this.clearFlags()
      window.sessionStorage.removeItem('propose_list_scroll_top')
      window.sessionStorage.removeItem('propose_list_search_conditions')
      if (this.keyword) {
        const url = null
        const self = this
        const callback = function () {
          self.keywordSearchCallbackFlag = true
          // 退職者一覧店舗を表示しない
          let workIndex = -1
          for (let i = 0; i < self.keywordShops.length; i++) {
            if (self.keywordShops[i].id == 800) {
              workIndex = i
              break
            }
          }
          if (workIndex !== -1) {
            self.keywordShops.splice(workIndex, 1)
          }
          // 瀬高店を表示しない
          let shopIdSetaka = -1
          for (let i = 0; i < self.keywordShops.length; i++) {
            if (self.keywordShops[i].id === '4') {
              shopIdSetaka = i
              break
            }
          }
          if (shopIdSetaka !== -1) {
            self.keywordShops.splice(shopIdSetaka, 1)
          }
          // 情報システム部を表示しない
          let shopSystem = -1
          for (let i = 0; i < self.keywordShops.length; i++) {
            if (self.keywordShops[i].id === '730') {
              shopSystem = i
              break
            }
          }
          if (shopSystem !== -1) {
            self.keywordShops.splice(shopSystem, 1)
          }
          // 採用部を表示しない
          let shopSaiyo = -1
          for (let i = 0; i < self.keywordShops.length; i++) {
            if (self.keywordShops[i].id === '750') {
              shopSaiyo = i
              break
            }
          }
          if (shopSaiyo !== -1) {
            self.keywordShops.splice(shopSaiyo, 1)
          }
          if (self.keyword) {
            self.focusGet()
          }
        }
        const data = {
          'keyword': this.keyword
        }
        this.$store.dispatch('PROPOSE_KEYWORD_SEARCH', {url: url, data: data, callback: callback})
      }
    },
    clearFlags: function () {
      this.keywordSearchCallbackFlag = false
      this.searchCallbackFlag = false
      this.selectShopName = ''
    },
    getProposeContent: function (proposeContent) {
      const stringMaxLength = 73
      if (proposeContent.length > stringMaxLength) {
        proposeContent = proposeContent.substring(0, stringMaxLength)
      }
      return proposeContent ? this.content(proposeContent) + '<br><span>…もっと見る</span>' : ''
    },
    getProposeProfileImagePath: function (proposeAttributes) {
      return proposeAttributes['profile-image-path'] ? proposeAttributes['profile-image-path'] : ''
    },
    getProposeImagePath: function (proposeAttributes) {
      return proposeAttributes['propose-1-image-path'] ? proposeAttributes['propose-1-image-path'] : ''
    },
    getProposeImageCount: function (proposeAttributes) {
      let count = 0
      if (proposeAttributes['propose-2-image-path']) count++
      if (proposeAttributes['propose-3-image-path']) count++
      return (count === 0) ? '' : '+' + count
    },
    goProfileDetail: function (userId) {
      window.sessionStorage.setItem('profile_detail_referrer', this.$router.history.current.path)
      this.$router.push({ path: '/profile/' + userId })
    },
    goProposeDetail: function (proposeId) {
      window.sessionStorage.setItem('propose_detail_referrer', this.$router.history.current.path)
      this.$router.push({ path: '/propose/' + proposeId })
    },
    goProposePersonalList: function (userId) {
      this.$router.push({ path: '/propose_personal_list/' + userId })
    },
    goProposeAllshopList: function () {
      this.$router.push({ path: '/propose_allshop_list' })
    },
    goProposeAdoptList: function () {
      this.$router.push({ path: '/propose_adopt_list' })
    },
    goProposeSearchList: function () {
      this.$router.push({ path: '/propose_search_list' })
    },
    getGoodClass: function (goodId) {
      return goodId ? '-on' : ''
    },
    toggleGood: function (proposeId) {
      if (!this.goodPushing) {
        this.goodPushing = true
        const goodId = this.getGoodId(proposeId)
        if (goodId) {
          const self = this
          const data = {
            propose_id: proposeId
          }
          const callback = function () {
            self.setGoodId(proposeId, '', self.getNewGoodsCount)
            self.goodPushing = false
          }
          this.$store.dispatch('GOOD_DELETE', {id: goodId, data: data, callback: callback})
        } else {
          const self = this
          const data = {
            propose_id: proposeId
          }
          const callback = function () {
            self.setGoodId(proposeId, self.getNewGoodId, self.getNewGoodsCount)
            self.goodPushing = false
          }
          this.$store.dispatch('GOOD_CREATE', {id: goodId, data: data, callback: callback})
        }
      }
    },
    getGoodId: function (proposeId) {
      for (const index in this.proposes) {
        if (this.proposes[index].id === proposeId) {
          return this.proposes[index].attributes['good-id']
        }
      }
      return ''
    },
    setGoodId: function (proposeId, goodId, goodsCount) {
      for (const index in this.proposes) {
        if (this.proposes[index].id === proposeId) {
          this.proposes[index].attributes['good-id'] = goodId
          this.proposes[index].attributes['goods-count'] = goodsCount
          break
        }
      }
    },
    focusGet: function () {
      this.searchShow = '-show'
      this.padding = 'padding-bottom: 300px;'
    },
    focusOut: function () {
      this.searchShow = ''
      this.padding = 'padding-bottom: 0px;'
    },
    short: function () {
      if (this.proposes.length > 0 && this.searchCallbackFlag) {
        return ''
      } else {
        return 'short-contents bg05'
      }
    },
    proposeHelp: function () {
      const button = document.getElementById('proposeHelpModalButton')
      button.click() // モーダル表示 イベント発火
    },
    content: function (word) {
      return word ? word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>') : ''
    },
    rmEmoji: function (text) {
      this.keyword = utils.removeEmoji(text)
    },
    handleScroll () {
      if (this.isScrollDoneFlag) {
        window.sessionStorage.removeItem('propose_list_scroll_top')
        this.isScrollDoneFlag = false
      }
    },
    getTask: function () {
      this.$store.dispatch('PROPOSE_TASK_GET')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/propose-search-list.js